import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language, LanguageService } from '@services/language/language.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-language-bar',
  templateUrl: './language-bar.component.html',
  styleUrls: ['./language-bar.component.scss'],
})
export class LanguageBarComponent implements OnInit {
  languages: Language[] = [];

  selectedLanguage: Language | null;

  cssUrl: string;

  cleanCssUrl: any;

  constructor(public translate: TranslateService, public languageService: LanguageService, public sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.sync();
    // The registry arrives asynchronously — a language added in admin shows up
    // here without a reload.
    this.languageService.languages$.subscribe(() => this.sync());
    this.languageService.load();
  }

  private sync() {
    this.languages = this.languageService.languages;
    this.selectedLanguage = this.languageService.getLanguage();
    this.cleanCssUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.languageService.cssUrl);
  }

  selectLanguage() {
    this.languageService.setLanguage(this.selectedLanguage);
    this.cleanCssUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.languageService.cssUrl);
  }

  /** Compares on `code` — the registry's identity. (Was `lcid`, which no longer exists.) */
  compareFn(a: Language, b: Language) {
    return !!b && a?.code === b?.code;
  }
}
